export default __webpack_public_path__ + "static/media/covinews.64709c48.png";